import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

const BASE_URL = BEPI_API.client;

export const ClientQuoteApi = {

  
  getEquipmentsCatalog: () => axios.get(`${BASE_URL}/catalog/equipments`),

    getCatalogServices: () =>
    axios.get(`${BASE_URL}/catalog/services`),

  createQuotation: (data) => axios.post(`${BASE_URL}/quotations`, data),
  

  getQuotationStatus: (clienteSlug, dominio, origemPk) => 
    axios.get(`${BASE_URL}/hub/status?cliente_slug=${clienteSlug}&dominio=${dominio}&origem_pk=${origemPk}`)
};
